module.exports = __webpack_public_path__ + "img/cert11x.b48218ca.png";